// frontend/src/pages/teacher/GradeDrillModal.js (فایل جدید)

import React, { useState, useEffect } from 'react';
import axiosInstance from '../../modules/api';
import { FaSave, FaSpinner, FaTimes, FaPencilAlt, FaInfoCircle } from 'react-icons/fa';

const GradeDrillModal = ({ isOpen, onClose, submission, onGraded }) => {
    const [score, setScore] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (submission) {
            // نمره فعلی را نمایش بده
            setScore(submission.score.toFixed(0)); 
            setError(null);
        }
    }, [submission]);

    if (!isOpen || !submission) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            // API جدید اصلاح نمره
            await axiosInstance.patch(`/core/teacher/drills/submission/${submission.id}/grade/`, {
                score: score,
            });
            
            onClose();
            onGraded(); // رفرش کردن صفحه والد
            
        } catch (err) {
            console.error("Drill grading failed:", err);
            setError(err.response?.data?.score || err.response?.data?.detail || "خطا در ثبت نمره.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{maxWidth: '500px'}}>
                <div className="modal-header">
                    <h2>
                        <FaPencilAlt className="ml-2" />
                        اصلاح نمره تمرین
                    </h2>
                    <button onClick={onClose} className="modal-close-btn"><FaTimes /></button>
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        
                        <div className="alert alert-danger" style={{backgroundColor: 'rgba(71, 85, 105, 0.3)', color: 'var(--text-medium)'}}>
                            <FaInfoCircle className="ml-2" />
                            شما در حال تغییر نمره خودکار سیستم هستید.
                        </div>

                        <p className="my-3">
                            <strong>درس:</strong> {submission.lesson_title} <br/>
                            <strong>تمرین:</strong> {submission.block_title}
                        </p>

                        {error && <div className="alert alert-danger">{error}</div>}
                        
                        <div className="form-group">
                            <label>نمره جدید (از 100)</label>
                            <input
                                type="number"
                                value={score}
                                onChange={(e) => setScore(e.target.value)}
                                placeholder="مثلا: 85"
                                max={100}
                                min={0}
                                required
                                disabled={loading}
                                className="text-left ltr" // برای اعداد
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="button button-secondary" onClick={onClose} disabled={loading}>
                            انصراف
                        </button>
                        <button type="submit" className="button button-primary" disabled={loading}>
                            {loading ? <FaSpinner className="spinner" /> : <FaSave />}
                            ذخیره نمره
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default GradeDrillModal;